import FleetCoreLoader from "../assets/images/animations/fleetcore-loader.gif";
import { FLEETCOR } from "./affiliations";

export const animationsRegistry = {
  [FLEETCOR]: FleetCoreLoader,
};

const imageRegistry = { ...animationsRegistry };

export default imageRegistry;
